import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Table, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faStore, faStoreAlt } from "@fortawesome/free-solid-svg-icons";
import CensusServices from "../../Services/CensusShopService";
import ClientServices from "../../Services/ClientShopService";
import PieChart from "../Common/PieChart";
import { Functions } from "../Common";
import { getPosition } from "../Common/Config";

const { FormateNumber } = Functions;

// Tile helper from provided snippet
function getTileBlock({ label, value, icon, color, customIcon }) {
	return (
		<div className="widget-chart d-flex flex-column align-items-center justify-content-center h-100Px">
			<h4 className="mb-3 text-muted">{label}</h4>
			<div className="icon-wrapper icon-wrapper-84 rounded-circle my-3">
				<div className="icon-wrapper-bg" style={{ background: `${color}AA` }} />
				{!customIcon && (
					<FontAwesomeIcon className="icon-wrapper" icon={icon} style={{ color: `${color}`, fontSize: 70 }} />
				)}
				{customIcon && <img className="manImg" src={icon} alt="icon" />}
			</div>
			<div className="widget-numbers text-muted">{FormateNumber(value)}</div>
		</div>
	);
}

const SelectedPolygonShopList = ({ isVisible, setIsVisible, selectedPolygon, HandleMarkerClick }) => {
	const [censusData, setCensusData] = useState([]);
	const [clientData, setClientData] = useState([]);
	const [smokingAreaData, setSmokingAreaData] = useState([]);

	const census_list = selectedPolygon?.data?.census_list || [];
	const storeList = selectedPolygon?.data?.store_list || [];
	const smoking_area_id = selectedPolygon?.data?.smoking_area_id || null;
	const population = selectedPolygon?.data?.population || 0;

	const sec = selectedPolygon?.data?.SEC || {};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const censusRes = await CensusServices.fetchCensusShops({
					params: {
						storeList: census_list,
						config: [
							"shop_data.census_id",
							"shop_details.name",
							"shop_data.primary_type",
							"shop_data.morning_footfall",
							"shop_data.afternoon_footfall",
							"shop_data.evening_footfall",
							"shop_details.coordinates"
						]
					}
				});
				setCensusData(censusRes.data.shopMarkers);

				const smokingRes = await CensusServices.fetchCensusShops({
					params: {
						storeList: smoking_area_id,
						config: [
							"shop_data.census_id",
							"shop_details.name",
							"shop_data.primary_type",
							"shop_data.morning_footfall",
							"shop_data.afternoon_footfall",
							"shop_data.evening_footfall",
							"shop_details.coordinates"
						]
					}
				});
				setSmokingAreaData(smokingRes.data.shopMarkers);

				const clientRes = await ClientServices.fetchClientShops({
					params: {
						storeList,
						config: [
							"code",
							"name",
							"outlet_data.avg_morning",
							"outlet_data.avg_afternoon",
							"outlet_data.avg_evening",
							"outlet_data.census_id",
							"location.coordinates"
						]
					}
				});
				setClientData(clientRes.data.shopMarkers);
			} catch (err) {
				console.error("Error fetching shop data:", err);
			}
		};

		if (storeList.length) fetchData();
	}, [storeList]);

	const HoReCaColumns = [
		{ title: "Census ID", dataIndex: ["shop_data", "census_id"], key: "census_id" },
		{ title: "Name", dataIndex: ["shop_details", "name"], key: "name" },
		{ title: "Type", dataIndex: ["shop_data", "primary_type"], key: "primary_type" },
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<Button
					type="primary"
					onClick={() => {
						HandleMarkerClick({
							id: record._id,
							data: {
								"Census ID": record.shop_data.census_id,
								"Shop Name": record.shop_data.name
							},
							position: getPosition(record.shop_details.coordinates),
							isClient: false,
							isPoi: true,
							showInfo: true
						});
						setIsVisible(false);
					}}
					style={{ marginLeft: 8 }}
					icon={<FontAwesomeIcon icon={faStore} />}
					className="px-2"
				>
					View Details
				</Button>
			)
		}
	];

	const clientColumns = [
		{ title: "Code", dataIndex: ["code"], key: "code" },
		{ title: "Name", dataIndex: ["name"], key: "name" },
		{ title: "Avg Morning", dataIndex: ["outlet_data", "avg_morning"], key: "avg_morning" },
		{ title: "Avg Afternoon", dataIndex: ["outlet_data", "avg_afternoon"], key: "avg_afternoon" },
		{ title: "Avg Evening", dataIndex: ["outlet_data", "avg_evening"], key: "avg_evening" },
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<Button
					type="primary"
					onClick={() => {
						HandleMarkerClick({
							id: record._id,
							data: {
								"Census ID": record.outlet_data.census_id,
								"Shop Name": record.name
							},
							position: getPosition(record.location.coordinates),
							isClient: true,
							isPoi: true,
							showInfo: true
						});
						setIsVisible(false);
					}}
					style={{ marginLeft: 8 }}
					icon={<FontAwesomeIcon icon={faStore} />}
					className="mr-2"
				>
					View Details
				</Button>
			)
		}
	];

	const censusColumns = [
		{ title: "Census ID", dataIndex: ["shop_data", "census_id"], key: "census_id" },
		{ title: "Name", dataIndex: ["shop_details", "name"], key: "name" },
		{ title: "Type", dataIndex: ["shop_data", "primary_type"], key: "primary_type" },
		{ title: "Morning Footfall", dataIndex: ["shop_data", "morning_footfall"], key: "morning_footfall" },
		{ title: "Afternoon Footfall", dataIndex: ["shop_data", "afternoon_footfall"], key: "afternoon_footfall" },
		{ title: "Evening Footfall", dataIndex: ["shop_data", "evening_footfall"], key: "evening_footfall" },
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<Button
					type="primary"
					onClick={() => {
						HandleMarkerClick({
							id: record._id,
							data: {
								"Census ID": record.shop_data.census_id,
								"Shop Name": record.shop_data.name
							},
							position: getPosition(record.shop_details.coordinates),
							isClient: false,
							isPoi: true,
							showInfo: true
						});
						setIsVisible(false);
					}}
					style={{ marginLeft: 8 }}
					icon={<FontAwesomeIcon icon={faStore} />}
					className="mr-2"
				>
					View Details
				</Button>
			)
		}
	];

	// inside your component, before the JSX:
	const smokingIds = React.useMemo(() => new Set(smokingAreaData.map(r => r._id)), [smokingAreaData]);

	return (
		<Modal
			open={isVisible}
			onCancel={() => setIsVisible(false)}
			footer={null}
			width={1400}
			title={selectedPolygon?.name || "Shop Details"}
		>
			{/* Summary Tiles */}
			<Row gutter={16} justify="center" style={{ marginBottom: 24 }}>
				<Col span={6} className="modal-stat modal-stat-container">
					{getTileBlock({
						label: "Population",
						value: population,
						icon: faUsers,
						color: "#eb2f96",
						customIcon: false
					})}
				</Col>
				<Col span={6} className="modal-stat modal-stat-container">
					{getTileBlock({
						label: "HoReCa Shops",
						value: censusData.length,
						icon: faStore,
						color: "#faad14",
						customIcon: false
					})}
				</Col>
				<Col span={6} className="modal-stat modal-stat-container">
					{getTileBlock({
						label: "Retail Shops",
						value: clientData.length,
						icon: faStoreAlt,
						color: "#52c41a",
						customIcon: false
					})}
				</Col>
				<Col span={8} className="modal-stat">
					<div className="widget-chart">
						<h4 className="mb-0 text-muted text-center">Shopper Profile</h4>
						<PieChart data={sec} />
					</div>
				</Col>
			</Row>

			<Table
				className="striped-table"
				dataSource={smokingAreaData}
				columns={censusColumns}
				rowKey={record => record._id}
				pagination={{ pageSize: 5 }}
				title={() => (
					<div
						style={{
							bold: "bold",
							fontSize: "16px",
							fontWeight: "bold"
						}}
					>
						Smoking Area
					</div>
				)}
				style={{ marginTop: 24 }}
			/>
			{/* Census Shops Table */}
			<Table
				className="striped-table"
				dataSource={censusData}
				columns={HoReCaColumns}
				rowKey={record => record._id}
				pagination={{ pageSize: 5 }}
				rowClassName={record => (smokingIds.has(record._id) ? "highlight-row" : "")}
				title={() => (
					<div
						style={{
							bold: "bold",
							fontSize: "16px",
							fontWeight: "bold"
						}}
					>
						HoReCa
					</div>
				)}
			/>

			{/* Retail Shops Table */}
			<Table
				className="striped-table"
				dataSource={clientData}
				columns={clientColumns}
				rowKey={record => record._id}
				pagination={{ pageSize: 5 }}
				title={() => (
					<div
						style={{
							bold: "bold",
							fontSize: "16px",
							fontWeight: "bold"
						}}
					>
						Retail Shops
					</div>
				)}
				style={{ marginTop: 24 }}
			/>
		</Modal>
	);
};

export default SelectedPolygonShopList;
